import Vue from 'vue';
import './plugins/vuetify';
import Router from 'vue-router';
import VeeValidate from "vee-validate";
// import App from './App_3.vue';
import App from './App_4.vue';
import Store from 'vue-store2-plugin';

//import Login from './pages/login'
//import Home from './components/Hello'

//import router from './router'
import common from "./functions/general";
import auth from "./functions/auth";
// import comm from "./functions/communication.api";
// import store2 from 'store2';

import i18n from './i18n'

Vue.use(Store);
Vue.use(VeeValidate);
Vue.use(Router);

Vue.config.productionTip = false;


var menu_check = auth.getMenu();

if (!menu_check) {

    (async () => {
      await auth.refreshMenu();
    })();

}

function requireAuth(to, from, next) {
    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        })
    } else {
        next();
    }
}

async function generate_routes(){
    let result = await common.wBackEndComm.PostData("routes/");

    let temp = [];
    if (result.data.Status == 1) {
        temp = result.data.Body;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }

    var component_mapping = {
        "/home": import("./pages/Page_Template/card_listing_pub"),
        // "/home": import("./components/Hello"),
        "/employees_listing": import("./pages/Employees/employees_listing_4"),
        "/company_listing": import("./pages/Company/company_listing_3"),
        "/department_listing": import("./pages/Department/department_listing_3"),
        "/timesheet_listing": import("./pages/Attendance/timesheet_listing"), // TBD Check backend page_auth
        "/login": import("./pages/login_1"),
        "/signup": import("./pages/signup"),
        "/timesheet_listing_hod": import("./pages/Attendance/timesheet_listing_hod"), // TBD Check backend page_auth
        "/emp_raw_activities": import("./pages/Attendance/emp_raw_activities"), // TBD Check backend page_auth
        "/log_listing": import("./pages/Log/log_listing"),
        "/appraisal_listing": import("./pages/Appraisal/appraisal_listing"), // cont check from here
        "/appraisal_form": import("./pages/Appraisal/appraisal_form"),
        "/job_grade_listing": import("./pages/Job_Grade/job_grade_listing"),
        "/position_listing": import("./pages/Position/position_listing"),
        "/card_listing": import("./pages/Page_Template/card_listing"),
        "/lms_listing": import("./pages/LMS/lms_listing1"),
        "/iframe_full": import("./pages/Page_Template/iframe_full"),
        "/change_pw": import("./pages/Page_Template/iframe_full"),
        "/appraisal_matrix": import("./pages/Appraisal/appraisal_matrix"),
        "/appraisal_my": import("./pages/Appraisal/appraisal_my"),
        "/card_listing_pub": import("./pages/Page_Template/card_listing_pub"),
        "/myvoice_table": import("./pages/myVoice/myvoice_table"),
        "/myvoice_form": import("./pages/myVoice/myvoice_form"),
        "/survey": import("./pages/myDesk/survey"),
        "/fitcorpers_listing": import("./pages/Employees/fitcorpers_listing_3"),
        "/org_chart": import("./pages/Org_Chart/org_chart"),
        "/calendar_google": import("./pages/myDesk/calendar_google"),
        "/media": import("./pages/Page_Template/media"),
        "/doc_template": import("./pages/myDoc/doc_template"),
        "/doc_create": import("./pages/myDoc/doc_create"),
        "/req_listing": import("./pages/myCareer/req_listing"),
        "/req_applicants_listing": import("./pages/myCareer/req_applicants_listing"),
        "/req_applicants_crud": import("./pages/myCareer/req_applicants_crud"),
        "/req_email_invi": import("./pages/myCareer/req_email_invi"),
        "/req_application_forms": import("./pages/myCareer/req_application_forms"),
        "/FPES-report-listing": import("./pages/FPES/Report-Listing"), // ?pageid=334
        "/FPES-report": import("./pages/FPES/Report"), // ?pageid=335
        "/Update-Fpes-Report-Entries": import("./pages/FPES/Update-Fpes-Report-Entries"), // ?pageid=336
        "/Submit-Evidence-Listing": import("./pages/FPES/Submit-Evidence-Listing"), // ?pageid=337
        "/Submit-Evidence": import("./pages/FPES/Submit-Evidence"), // ?pageid=338
        "/Submit-Evidence-Crud": import("./pages/FPES/Submit-Evidence-Crud"), // ?pageid=339
        "/Submit-Evidence-Step2-Crud": import("./pages/FPES/Submit-Evidence-Step2-Crud"), // ?pageid=340
        "/req_application_fill_forms": import("./pages/myCareer/req_application_fill_forms"),
        "/FPES-Admin-Upload": import("./pages/FPES/Admin-Upload"),
        "/FPES-Admin-Factor-Listing": import("./pages/FPES/Admin-Factor-Listing"),
        "/req_log": import("./pages/myCareer/req_log"),
        "/forget_pw": import("./pages/forget_pw"),
        "/Appraisal-Form-V2": import("./pages/Appraisal/appraisal_form_v2"),
        // "/Appraisal-Form-V2": import("./pages/Appraisal/appraisal_form_v3"), // route to _v3
        "/FPES-report-hr": import("./pages/FPES/Report-hr"),
        "/Appraisal-Acknowledgement-Page": import("./pages/FPES/Appraisal-Acknowledgement-Page"),
        "/events_listing": import("./pages/Events/events_listing"),
        "/events_crud": import("./pages/Events/events_crud"),
        "/events_btrt": import("./pages/Events/events_btrt"),
        "/card_listing_arg": import("./pages/Page_Template/card_listing_arg")
    };
    let routes = [];
    let len = temp.length;

    routes.push({
        path: '/',
        redirect: '/home'
    });

    routes.push({
        path: '*', // any path not matching, route to home
        redirect: '/home'
    });


    for (var i=0; i<len; i++) {
        let el = temp[i];

        routes.push({
            path: el["path"],
            component: () => component_mapping[el["path"]],
            beforeEnter: el["beforeEnter"]?requireAuth:null
        });
    }

	routes.push({
		path:"/iframe_full_arg",
		name:"iframe_full_arg",
		component:() => import(`./pages/Page_Template/iframe_full_arg.vue`),
		beforeEnter:requireAuth
	});

	routes.push({
		path:"/media_arg",
		name:"media_arg",
		component:() => import(`./pages/Page_Template/media_arg.vue`),
		beforeEnter:requireAuth
	});
    
    routes.push({
		path:"/temp",
		name:"temp",
		component:() => import(`./pages/1_temp/temp.vue`),
		// beforeEnter:requireAuth
	});

    return routes;
}
generate_routes().then(function(res){
    //router.options.routes = res;
    var router = new Router({
        base: __dirname,
        mode: 'history',
        routes:res
    })
    // console.log("func",res);
    window.MainApp = new Vue({
        router,
        i18n,
        render: h => h(App),
    }).$mount('#app')
});

// window.MainApp = new Vue({
// 	router,
// 	render: h => h(App),
// }).$mount('#app')